import { render, staticRenderFns } from "./ManageColumnField.vue?vue&type=template&id=4e83e195&scoped=true&"
import script from "./ManageColumnField.vue?vue&type=script&lang=ts&"
export * from "./ManageColumnField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e83e195",
  null
  
)

export default component.exports